export default "__VITE_ASSET__DMa6WySn__"